// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hovered[data-v-9d46289c] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(160, 174, 192, var(--tw-bg-opacity));\n}\n.nopointer[data-v-9d46289c] {\n  pointer-events: none;\n  touch-action: none;\n}\n.peek[data-v-9d46289c] {\n  transition: bottom 0.5s linear;\n}\n", ""]);
// Exports
module.exports = exports;
